<h1 mat-dialog-title class="columns-reorder-header aza-pa-dialog-title" translate>{{ data.translatableTitleString }}</h1>
<div mat-dialog-content class="aza-pa-dialog-content">
    <div class="reorder-container columns-to-display aza-pa-flex-column aza-pa-content-center">
        <div cdkDropList [cdkDropListData]="data.items" class="reorder-list aza-pa-border aza-cmp-rounded-border"
             (cdkDropListDropped)="drop($event)">
            <div class="reorder-box drag-item aza-pa-flex-row aza-pa-border aza-pa-padding" *ngFor="let item of data.items" cdkDrag>{{item.name}}</div>
        </div>
    </div>
</div>
<div mat-dialog-actions class="aza-pa-dialog-actions">
    <azavista-flat-button (click)="onCancelClick()" color="primary" class="aza-pa-dialog-action-cancel-button"><span translate>CANCEL</span></azavista-flat-button>
    <azavista-button (click)="onApplyClick()" color="primary" class="aza-pa-dialog-action-apply-button"><span translate>APPLY</span>
    </azavista-button>
</div>
